import React from "react";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { solutions } from "../mock";

const Solutions = () => {
  const navigate = useNavigate();
  return (
    <section className="relative py-20 lg:py-28 overflow-hidden bg-[#050f24]" data-testid="solutions-section">
      <div className="absolute -left-40 top-20 w-[500px] h-[500px] rounded-full bg-blue-600/10 blur-3xl" />
      <div className="absolute right-0 bottom-10 w-[400px] h-[400px] rounded-full bg-white/6 blur-3xl" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <p className="text-white text-sm font-semibold tracking-[0.16em] uppercase mb-3">What We Do</p>
          <h2 className="text-4xl lg:text-[44px] font-bold text-white" style={{ fontFamily: "Archivo, sans-serif" }}>
            Explore Our Tech Solutions
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {solutions.map((s, idx) => (
            <div
              key={s.slug}
              onClick={() => navigate(`/solutions/${s.slug}`)}
              className="group relative rounded-xl overflow-hidden cursor-pointer aspect-[3/4] shadow-md hover:shadow-[0_0_30px_rgba(255,255,255,0.18)] ring-1 ring-white/5 hover:ring-white/40 transition-all duration-500 reveal"
              style={{ transitionDelay: `${(idx % 4) * 60}ms` }}
              data-testid={`solution-card-${s.slug}`}
            >
              <img
                src={s.image}
                alt={s.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050f24] via-[#050f24]/40 to-transparent transition-opacity duration-500 group-hover:opacity-0" />

              <h3 className="absolute bottom-5 left-5 right-5 text-white text-[22px] font-semibold leading-tight transition-opacity duration-300 group-hover:opacity-0" style={{ fontFamily: "Archivo, sans-serif" }}>
                {s.title}
              </h3>

              <div className="absolute inset-0 bg-[#071d3f]/94 backdrop-blur-[2px] opacity-0 group-hover:opacity-100 transition-opacity duration-400 flex flex-col justify-between p-6">
                <div>
                  <h3 className="text-white text-[22px] font-semibold leading-tight mb-4 translate-y-3 group-hover:translate-y-0 transition-transform duration-400" style={{ fontFamily: "Archivo, sans-serif" }}>
                    {s.title}
                  </h3>
                  <p className="text-white/80 text-[15px] leading-relaxed translate-y-3 group-hover:translate-y-0 transition-transform duration-500">
                    {s.short}
                  </p>
                </div>
                <span className="inline-flex items-center gap-2 text-white text-sm font-semibold translate-y-3 group-hover:translate-y-0 transition-transform duration-500">
                  Learn More <ArrowRight size={15} />
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
